module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("ALIVE")]), _vm._v(" "), _c('p', {
    staticClass: "chap_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("B")]), _vm._v("eing thrust from heaven is where Satan’s utter hatred for our salvation’s plan is derived")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And like the wanted posters of old, he will do anything to get your soul, dead or alive.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("All souls are important to God the Father, and He sends His shepherds to guide the flocks of souls back to heaven’s gate")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And He goes to extraordinary lengths so the utterly lost are not ever left alone and to suffer a most terrible fate.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Christ’s plan of salvation came with God the Father’s consent")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("So that every soul, born of the flesh, can return from whence they were sent.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("We all live our lives whether long or short")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And with true repentance will return with our eternal mate and to our eternal family report.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Christ the Savior’s sacrifice will not ever be in vain")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If we choose to grasp God’s iron rod to ensure our return to the highest heavenly plane.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Being thrust from heaven is where Satan’s utter hatred for our salvation’s plan is derived")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And like the wanted posters of old, he will do anything to get your soul, dead or alive.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d4a9e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap007.vue
// module id = 87
// module chunks = 0